import { Button, Col, Row, Select, Switch } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import SectionTitle from 'components/SectionTitle'
import { DataContext } from 'contexts/DataContextContainer'
import { capitalize } from 'lib/string'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdAdd } from 'react-icons/md'
import { Link, useHistory, useParams } from 'react-router-dom'
import {
  useBookCoversQuery,
  useCoverTemplateCategoriesQuery,
  useCoverTemplatesQuery,
} from 'store/queries'
import { CoverTemplatesContainer } from './style'

function CoverTemplates() {
  const { t } = useTranslation()
  const history = useHistory()
  const { bookId } = useParams()
  const { lang } = useContext(DataContext)

  const [filters, setFilters] = useState({
    categories: [],
    showOwnTemplates: true,
  })

  const { isLoading: isTemplatesLoading, data: publicTemplates } =
    useCoverTemplatesQuery(filters)
  const { isLoading: isBookCoversLoading, data: bookCovers } =
    useBookCoversQuery(bookId)
  const { isLoading: isCategoriesLoading, data: templateCategories } =
    useCoverTemplateCategoriesQuery()

  const isLoading =
    isTemplatesLoading || isBookCoversLoading || isCategoriesLoading

  const categoryOptions = templateCategories?.map((category) => {
    return {
      value: category.id,
      label: capitalize(category[lang] || category.name),
    }
  })

  return (
    <CoverTemplatesContainer className="section-container">
      <SectionTitle>{t('cover_template_page_title')}</SectionTitle>

      <p className="cover-template-subtitle">
        {t('cover_template_page_subtitle')}
      </p>
      <Row className="mb-4 ctrl-row" gutter={[24, 24]}>
        <Col xs={{ span: 12 }} sm={{ span: 8 }}>
          <Select
            mode="multiple"
            allowClear
            placeholder="Cover Categories"
            defaultValue={[]}
            style={{ width: '100%' }}
            onChange={(categoryIds) =>
              setFilters({ ...filters, categories: categoryIds })
            }
            options={categoryOptions}
            value={filters.categories}
          />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 7 }}
          lg={{ span: 8 }}
          className="d-flex align-items-center"
        >
          <label
            className="mb-0 switch-label"
            htmlFor="private-templates-switch"
          >
            {t('show_own_templates')}
          </label>
          <Switch
            defaultChecked
            id="private-templates-switch"
            className="ml-2"
            onChange={(checked) =>
              setFilters({ ...filters, showOwnTemplates: checked })
            }
          />
        </Col>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 9 }}
          lg={{ span: 8 }}
          className="d-flex align-items-center btn-col"
        >
          <Button
            className="btn-blue btn-dash btn-primary template-btn"
            onClick={() =>
              history.push(
                `/dashboard/book/${bookId}/publish/cover-design?isNew=true`,
              )
            }
          >
            <MdAdd className="mr-2" />
            {t('create_own_template')}
          </Button>
        </Col>
      </Row>
      {isLoading ? (
        <StyledLoader />
      ) : (
        <>
          {filters.showOwnTemplates && !!bookCovers?.length && (
            <>
              <h4>My Covers:</h4>
              <Row gutter={[24, 16]}>
                {bookCovers.map((template) => (
                  <Col
                    key={template.id}
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 8 }}
                    lg={{ span: 6 }}
                    xxl={{ span: 4 }}
                  >
                    <div className="template-item">
                      <Link
                        to={`/dashboard/book/${bookId}/publish/cover-design/${template.id}`}
                      >
                        <>
                          <h6 className="template-title">
                            {template.template_name}
                          </h6>
                          <img
                            className="template-icon"
                            alt="Cover thumbnail"
                            src={template.thumbnailUrl}
                          />
                        </>
                      </Link>
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          )}
          <>
            <h4>Cover Templates:</h4>
            <Row gutter={[24, 16]}>
              {publicTemplates.map((template) => (
                <Col
                  key={template.id}
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 8 }}
                  lg={{ span: 6 }}
                  xxl={{ span: 4 }}
                >
                  <div className="template-item">
                    <Link
                      to={`/dashboard/book/${bookId}/publish/cover-design?templateId=${template.id}`}
                    >
                      <>
                        <h6 className="template-title">
                          {template.template_name}
                        </h6>
                        <img
                          className="template-icon"
                          alt="Template thumbnail"
                          src={template.thumbnailUrl}
                        />
                      </>
                    </Link>
                  </div>
                </Col>
              ))}
            </Row>
          </>
        </>
      )}
    </CoverTemplatesContainer>
  )
}

export default CoverTemplates
